import React, { PureComponent } from 'react';
import chartJS from 'chart.js';
import { options } from './options';
import { comparison } from './comparison';

let radarChart = '';

const data = {
    labels: [
        '\ue974',
        '\ue96a',
        '\ue971',
        '\ue972',
        '\ue973',
        '\ue96c',
        '\ue970',
        '\ue96e',
        '\ue96b',
        '\ue96f'
    ],
    datasets: [{
        label: 'Your results',
        backgroundColor: ['rgba(206, 4, 56, 0.31)'],
        borderColor: '#ce0538',
        borderWidth: 2,
        boxShadow: 'inset 0 0 36px 0 rgba(206, 4, 56, 0.41)',
        pointBackgroundColor: ['#ffffff', '#ce0538', '#ce0538', '#ce0538', '#ce0538', '#ce0538', '#ce0538', '#ce0538', '#ce0538', '#ce0538'],
        pointBorderColor: '#ce0538',
        pointHoverBackgroundColor: '#fff',
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHoverBorderWidth: 2,
        pointHitRadius: 30,
        //pointStyle: [yourImage2, yourImage, yourImage, yourImage, yourImage, yourImage, yourImage, yourImage, yourImage, yourImage],
        pointStyle: 'circle',
        data: []
    },
    {
        label: 'Your industry',
        borderWidth: 1,
        pointBackgroundColor: '#ce0538',
        pointBorderColor: '#ce0538',
        pointHoverBackgroundColor: '#fff',
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 20,
        boxShadow: 'inset 0 0 12px 0 rgba(255, 255, 255, 0.36)',
        data: []
    }]
};


class Graph extends PureComponent {
    state = {
        industryData: null,
        britishData: null,
        userData: null,
        activeID: null,
        count: 0,
    }

    componentDidMount() {
        this.setData();
        this.setUserData();

        if (window.innerWidth < 992) {
            this.startCarousel();
        }
    }

    startCarousel() {
        const chartIcons = document.querySelectorAll('[class*="chartwrap-icon"]');

        this.interval = setInterval(() => {
            // Increment count
            this.setState(prevState => ({
                count: (prevState.count % chartIcons.length) + 1
            }));
        }, 7500);
    }

    componentDidUpdate(prevProps, prevState) {
        // Push message after state has been updated
        if (prevState.count !== this.state.count) {
            this.pushMessage(this.state.count);
        }
    }

    // Set industry data
    setData() {
        const { soc } = this.props;

        console.log(soc);
        
        const industryData = comparison.map(comp => {
            const max = comp.data.find(catData => catData.soc == soc).max;
            const min = comp.data.find(catData => catData.soc == soc).min;
            const average = Math.round((max + min) / 2);
            return average;
        });
        const britishData = comparison.map(comp => {
            const max = comp.average.max;
            const min = comp.average.min;
            const average = Math.round((max + min) / 2);
            return average;
        });

        this.setState({
            industryData,
            britishData
        });
    }

    getBrowserWidth() {
        const w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        width = w.innerWidth||e.clientWidth||g.clientWidth,
        height = w.innerHeight||e.clientHeight||g.clientHeight;

        return width;
    }

    setUserData() {
        const { categories } = this.props;
        const userData = categories.map(category => category.score);
        this.setState({
            userData
        }, () => {
            this.initGraph();
        });
    }

    pushMessage(categoryID) {
        this.setState({
            activeID: categoryID
        });

        if (this.getBrowserWidth() < 992) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }

        const { categories, setMessage, compareToIndustry, setCompareToIndustry } = this.props;   
        
        const selectedCategory = categories.find(category => category.category.id == categoryID);
        const categoryTitle = selectedCategory.category.title;
        const categoryClass = selectedCategory.category.class;
        const { score } = selectedCategory;
        setMessage(categoryID, score, categoryTitle, categoryClass);
    }

    handleClick(categoryID) {
        clearInterval(this.interval);
        this.pushMessage(categoryID);
    }

    componentWillReceiveProps(nextProps) {
        const { industryData, britishData } = this.state;
        if (this.props.compareToIndustry != nextProps.compareToIndustry) {
            if (nextProps.compareToIndustry) {
                radarChart.data.datasets[1].data = industryData;
                radarChart.data.datasets[1].backgroundColor = ['rgba(131,102,228, 0.13)'];
                radarChart.data.datasets[1].borderColor = '#8366E4';
            } else {
                radarChart.data.datasets[1].data = britishData;
                radarChart.data.datasets[1].backgroundColor = ['rgba(18,212,177, 0.13)'];
                radarChart.data.datasets[1].borderColor = '#12D4B1';
            }
            radarChart.update();
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    initGraph() {
        const { industryData, userData } = this.state;

        if (industryData && userData) {
            const chart = document.getElementById('Radar');
            data.datasets[0].data = userData;
            data.datasets[1].data = industryData;
            radarChart = new Chart(chart, {
                type: 'radar',
                data,
                options
            });
        }
    }

    render() {
        const { activeID } = this.state;

        return (
            <div className="chartwrap">
                <div className={activeID == 1 ? 'chartwrap-icon __active' : activeID ? 'chartwrap-icon' : 'chartwrap-icon __white'}  onClick={(e) => this.handleClick(1)}></div>
                <div className={activeID == 2 ? 'chartwrap-icon2 __active' : activeID ? 'chartwrap-icon2' : 'chartwrap-icon2 __white'}  onClick={(e) => this.handleClick(2)}></div>
                <div className={activeID == 3 ? 'chartwrap-icon3 __active' : activeID ? 'chartwrap-icon3' : 'chartwrap-icon3 __white'}  onClick={(e) => this.handleClick(3)}></div>
                <div className={activeID == 4 ? 'chartwrap-icon4 __active' : activeID ? 'chartwrap-icon4' : 'chartwrap-icon4 __white'}  onClick={(e) => this.handleClick(4)}></div>
                <div className={activeID == 5 ? 'chartwrap-icon5 __active' : activeID ? 'chartwrap-icon5' : 'chartwrap-icon5 __white'}  onClick={(e) => this.handleClick(5)}></div>
                <div className={activeID == 6 ? 'chartwrap-icon6 __active' : activeID ? 'chartwrap-icon6' : 'chartwrap-icon6 __white'}  onClick={(e) => this.handleClick(6)}></div>
                <div className={activeID == 7 ? 'chartwrap-icon7 __active' : activeID ? 'chartwrap-icon7' : 'chartwrap-icon7 __white'}  onClick={(e) => this.handleClick(7)}></div>
                <div className={activeID == 8 ? 'chartwrap-icon8 __active' : activeID ? 'chartwrap-icon8' : 'chartwrap-icon8 __white'}  onClick={(e) => this.handleClick(8)}></div>
                <div className={activeID == 9 ? 'chartwrap-icon9 __active' : activeID ? 'chartwrap-icon9' : 'chartwrap-icon9 __white'}  onClick={(e) => this.handleClick(9)}></div>
                <div className={activeID == 10 ? 'chartwrap-icon10 __active' : activeID ? 'chartwrap-icon10' : 'chartwrap-icon10 __white'}  onClick={(e) => this.handleClick(10)}></div>
                <canvas id="Radar" style={{ width: '100%', height: '100%' }} />
            </div>
        );
    }
}

export default Graph;



// WEBPACK FOOTER //
// ./src/Results/Graph.js